if ("serviceWorker" in navigator) {
    if (navigator.serviceWorker.controller) {
        //console.log("[PWA Builder] active service worker found, no need to register");
    } else {
        navigator.serviceWorker
            .register('/serviceworker.js', { scope: '/' })
            .then(function (reg) {
                //console.log("[PWA Builder] Service worker has been registered for scope: " + reg.scope);
            })
            .catch(function (error) {
                console.log("[PWA Builder] Service worker registration failed: " + error);
            });
    }
}